import { routes } from '@/utils/routes';
import { DS_SPACING_UNITS } from '@calm/evexia-design-tokens';
import { MediaImage } from '@calm/evexia-web-sdk';
import BackButton from '@rhg/components/back-button';
import { Heading } from '@rhg/components/heading';
import { ProgramHeaderWrapper } from '@rhg/components/program/program-header/wrapper';
import { PackDetailsPaddedContainer } from '../layout';

const styleNoImagePackDetailsHeader = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    py: DS_SPACING_UNITS.SECTION,
};

const stylePackDetailsHeader = {
    py: DS_SPACING_UNITS.SECTION,
};

export const PackDetailsHeader = ({
    title,
    subtitle,
    imageData,
}: {
    title?: string;
    subtitle?: string;
    imageData?: MediaImage;
}) => {
    if (!title) {
        return null;
    }

    if (!imageData) {
        return (
            <PackDetailsPaddedContainer sx={styleNoImagePackDetailsHeader}>
                <Heading
                    leftButton={<BackButton fallbackRoute={routes.discover} />}
                    title={title}
                    titleAlign="center"
                    subtitle={subtitle}
                    subtitleAlign="center"
                    subtitleWillRenderLinks
                    subTitleColumns={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 8 }}
                    spacing={DS_SPACING_UNITS.SECTION}
                />
            </PackDetailsPaddedContainer>
        );
    }

    return (
        <>
            <ProgramHeaderWrapper
                hideImageMask
                programImageSrc={imageData?.url}
                fallbackBackRoute={routes.discover}
            />
            <PackDetailsPaddedContainer sx={stylePackDetailsHeader}>
                <Heading
                    title={title}
                    titleAlign="left"
                    subtitle={subtitle}
                    subtitleAlign="center"
                    subtitleWillRenderLinks
                    spacing={DS_SPACING_UNITS.SECTION}
                />
            </PackDetailsPaddedContainer>
        </>
    );
};
